export const SETUP_PENDING_VERIFICATION = 1;
export const SETUP_PENDING_TOS = 2;
export const SETUP_COMPLETE = 3;
export const SETUP_ORPHANED = 4;
